import { Injectable, Inject, forwardRef,} from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository,Raw, getConnection } from 'typeorm';
import { AllWelfareResponseModel,  SingleWelfareResponseModel,  WelfareResponseModel,  } from './dto/welfare-response-model';
import { WelfareEntity } from './welfare.entity';
import { WelfareStatusWiseResponseModel} from './dto/welfare-status-response.model';
import { WelfareDeleteDTO, WelfareDTO,  WelfareStatusDto } from './dto/welfare.dto';
import * as fs from 'fs';
import { sendFCMNotifications, sendTextLocalSMS } from '../shared/mobileOTP';
import { WelfareStatusEntity } from './welfare-status.entity';
import { WelfareFilesEntity } from './welfare-files.entity';
import { ProfileService } from '../profile/profile.service';
import { VillageService } from '../village/village.service';
import { NotificationsEntity } from '../notifications/notifications.entity';

@Injectable()
export class WelfareService {
  constructor(
    @InjectRepository(WelfareEntity)
    private welfareRepository: Repository<WelfareEntity>,
    @InjectRepository(WelfareStatusEntity)
    private welfarestatusRepository: Repository<WelfareStatusEntity>,
    @InjectRepository(WelfareFilesEntity)
    private welfarefilesRepository: Repository<WelfareFilesEntity>,
    @InjectRepository(NotificationsEntity)
    private notifyRepo:Repository<NotificationsEntity>,
    @Inject(forwardRef(()=>ProfileService))
    private profileService: ProfileService,
    private villageService: VillageService,
  ) {}

  async sendSMS(mobileNo:string, text: string, id:string) {
    return await sendTextLocalSMS(mobileNo, text, id)
    .then(() => {      
    console.log('sms sent successufully');
    return true;
    })
    .catch((err) => {
    console.log('error in sending sms ', err);
    return false;
    });
  }

  async sendNotify(text) {
    return await sendFCMNotifications(text)
    .then(() => {      
      console.log('notification sent successufully');
      return true;
    })
    .catch((err) => {
      console.log('error in sending notification ', err);
      return false;
    });
  }

  async createWelfare(queryParams, WelfareDTO:WelfareDTO) {
    try { 
      WelfareDTO.status = true;
      WelfareDTO.createdUser = WelfareDTO.userId;
      WelfareDTO.currentStatus = 'new';
      if(WelfareDTO.villageId > 0) {
        WelfareDTO.villageId = WelfareDTO.villageId
      } else {
        WelfareDTO.villageId = null
      }
      const user = await this.profileService.getUserByUId(WelfareDTO.userId); 
      user.firstName = user.firstName!=null?user.firstName:'';     
      if(queryParams.apiVersion == 1) {
        const savedPost = await this.welfareRepository.save(WelfareDTO);
        const Welfarestatus= await this.welfarestatusRepository.save({
          welfareId:savedPost.Id,
          userId:savedPost.userId,
          welfareStatus:'new',                
          createdUser:WelfareDTO.userId,
          versionFlag:WelfareDTO.versionFlag
        })
        if(savedPost) {
          const sentSMS = await this.sendSMS(WelfareDTO.mobileNo,`Your Welfare is registered by ${user.firstName}, your Welfare ID is ${savedPost.Id} Please download netR App to get updates at Androd users : https://play.google.com/store/apps/details?id=com.varahasolutions.arooriRamesh and IOS users : https://apps.apple.com/us/app/aroori/id1597891250 - SRI VARAHA SOLUTIONS`,process.env.BlkSMS_WELFARE_TEMPID)
          let msg = {
            to : `${user.user.fcmToken}`,
            collapse_key : "type_a",
            notification : {
              body : `Your Welfare Created with ${savedPost.Id}`,
              title: "Create Welfare"
            },
            data : {
              body : `Your Welfare Created  with ${savedPost.Id}`,
              title: "Create Welfare",
              key_1 : "",
              key_2 : ""
            }
          }
          await this.notifyRepo.save({
            title:'Create Welfare',
            message:`Your Welfare Created with ${savedPost.Id}`,
            typeId:5,
            userId:WelfareDTO.userId,
            targetId:savedPost.Id,
            status:true
          })
          if(user.user.fcmToken) {                  
            await this.sendNotify(msg);
          }
          const newUsr = await this.profileService.getProfileByPhone(WelfareDTO.mobileNo);
          if(newUsr) {
            let msg1 = {
              to : `${newUsr.user.fcmToken}`,
              collapse_key : "type_a",
              notification : {
                body : `Your Welfare is registered by ${user.firstName}, your Welfare ID is ${savedPost.Id}`,
                title: "Create Welfare"
              },
              data : {
                body : `Your Welfare is registered by ${user.firstName}, your Welfare ID is ${savedPost.Id}`,
                title: "Create Welfare",
                key_1 : "",
                key_2 : ""
              }
            }
            await this.notifyRepo.save({
              title:'Create Welfare',
              message:`Your Welfare is registered by ${user.firstName}, your Welfare ID is ${savedPost.Id}`,
              typeId:5,
              userId:newUsr.userId,
              targetId:savedPost.Id,
              status:true
            })                  
            if(newUsr.user.fcmToken) {
              await this.sendNotify(msg1);
            }
          }
          return savedPost;
        } else {
          return null;
        }
      } else {
        const savedPost = await this.welfareRepository.save(WelfareDTO);
        const Welfarestatus= await this.welfarestatusRepository.save({
          welfareId:savedPost.Id,
          userId:savedPost.userId,
          welfareStatus:'new',                
          createdUser:WelfareDTO.userId,
          versionFlag:WelfareDTO.versionFlag
        })
        if(savedPost) {
          const sentSMS = await this.sendSMS(WelfareDTO.mobileNo,`Your Welfare is registered by ${user.firstName}, your Welfare ID is ${savedPost.Id} Please download netR App to get updates at Androd users : https://play.google.com/store/apps/details?id=com.varahasolutions.arooriRamesh and IOS users : https://apps.apple.com/us/app/aroori/id1597891250 - SRI VARAHA SOLUTIONS`,process.env.BlkSMS_WELFARE_TEMPID)
          let msg = {
            to : `${user.user.fcmToken}`,
            collapse_key : "type_a",
            notification : {
              body : `Your Welfare Created with ${savedPost.Id}`,
              title: "Create Welfare"
            },
            data : {
              body : `Your Welfare Created  with ${savedPost.Id}`,
              title: "Create Welfare",
              key_1 : "",
              key_2 : ""
            }
          }
          await this.notifyRepo.save({
            title:'Create Welfare',
            message:`Your Welfare Created with ${savedPost.Id}`,
            typeId:5,
            userId:WelfareDTO.userId,
            targetId:savedPost.Id,
            status:true
          })
          if(user.user.fcmToken) {                  
            await this.sendNotify(msg);
          }
          const newUsr = await this.profileService.getProfileByPhone(WelfareDTO.mobileNo);
          if(newUsr) {
            let msg1 = {
              to : `${newUsr.user.fcmToken}`,
              collapse_key : "type_a",
              notification : {
                body : `Your Welfare is registered by ${user.firstName}, your Welfare ID is ${savedPost.Id}`,
                title: "Create Welfare"
              },
              data : {
                body : `Your Welfare is registered by ${user.firstName}, your Welfare ID is ${savedPost.Id}`,
                title: "Create Welfare",
                key_1 : "",
                key_2 : ""
              }
            }
            await this.notifyRepo.save({
              title:'Create Welfare',
              message:`Your Welfare is registered by ${user.firstName}, your Welfare ID is ${savedPost.Id}`,
              typeId:5,
              userId:newUsr.userId,
              targetId:savedPost.Id,
              status:true
            })                  
            if(newUsr.user.fcmToken) {
              await this.sendNotify(msg1);
            }
          }
          return savedPost;
        } else {
          return null;
        }
      }
    } catch (error) {
      throw error;      
    }
  }

  async createWelfarefiles(queryParams,filesData,welfareId): Promise<WelfareResponseModel> {
   
      const response = new WelfareResponseModel();
      try {
              if(queryParams.apiVersion == 1) {
               
                const savedWelfare = await this.welfarefilesRepository.save(filesData);
                
                  const updatedData = await this.welfareRepository.findOne({
                      relations:['welfaretype'],
                      where:{Id:welfareId}
                  });
                  if (savedWelfare) {
                    response.status = true;
                    response.data = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Welfare created successfully';
                    response.intlCode = 11100;
                  } else {
                    throw new ErrorResponse(11106, 'Welfare not created');
                  }
                } else {
                  const savedWelfare = await this.welfarefilesRepository.save(filesData);
                
                  const updatedData = await this.welfareRepository.findOne({
                      relations:['welfaretype'],
                      where:{Id:welfareId}
                  });
                  if (savedWelfare) {
                    response.status = true;
                    response.data = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Welfare created successfully';
                    response.intlCode = 11100;
                  } else {
                    throw new ErrorResponse(11106, 'Welfare not created');
                  }
              }
          
          return response;
      }
     
      catch (error) {
          throw error;
      }
  
    }  
  

  async updateWelfare(queryParams, filesData,WelfareDTO: WelfareDTO, request:Request): Promise<SingleWelfareResponseModel> {
    const response = new SingleWelfareResponseModel();
    try {
      const oldData = await this.welfareRepository.findOne({
        where:{Id:WelfareDTO.Id}
      })
      if(WelfareDTO.text) {
        WelfareDTO.text = WelfareDTO.text
      } else {
        WelfareDTO.text = oldData.text
      }
      if(WelfareDTO.welfaretypeId) {
        WelfareDTO.welfaretypeId = WelfareDTO.welfaretypeId
      } else {
        WelfareDTO.welfaretypeId = oldData.welfaretypeId
      }
      if(WelfareDTO.mobileNo) {
        WelfareDTO.mobileNo = WelfareDTO.mobileNo
      } else {
        WelfareDTO.mobileNo = oldData.mobileNo
      }
      if(WelfareDTO.firstName) {
        WelfareDTO.firstName = WelfareDTO.firstName
      } else {
        WelfareDTO.firstName = oldData.firstName
      }
      if(WelfareDTO.lastName) {
        WelfareDTO.lastName = WelfareDTO.lastName
      } else {
        WelfareDTO.lastName = oldData.lastName
      }
      if(WelfareDTO.address) {
        WelfareDTO.address = WelfareDTO.address
      } else {
        WelfareDTO.address = oldData.address
      }
      if(WelfareDTO.villageId) {
        WelfareDTO.villageId = WelfareDTO.villageId
      } else {
        WelfareDTO.villageId = oldData.villageId
      }
      if(WelfareDTO.amount) {
        WelfareDTO.amount = WelfareDTO.amount
      } else {
        WelfareDTO.amount = oldData.amount
      }
      if(WelfareDTO.email) {
        WelfareDTO.email = WelfareDTO.email
      } else {
        WelfareDTO.email = oldData.email
      }
      if(WelfareDTO.versionFlag) {
        WelfareDTO.versionFlag = WelfareDTO.versionFlag
      } else {
        WelfareDTO.versionFlag = oldData.versionFlag
      }
      WelfareDTO.updatedUser = WelfareDTO.userId;
      let images: any[] = [];
      let finaObj = {
        text:WelfareDTO.text,
        welfaretypeId:WelfareDTO.welfaretypeId,
        mobileNo:WelfareDTO.mobileNo,
        firstName:WelfareDTO.firstName,
        lastName:WelfareDTO.lastName,
        address:WelfareDTO.address,
        villageId:WelfareDTO.villageId,
        amount:WelfareDTO.amount,
        email:WelfareDTO.email,
        userId:WelfareDTO.userId,
        updatedUser:WelfareDTO.updatedUser
      }
      if(queryParams.apiVersion == 1) {
        const updatePostType = await this.welfareRepository.update(WelfareDTO.Id, finaObj);
        const getOldFiles = await this.welfarefilesRepository.find({
          where:{welfareId:WelfareDTO.Id}
        })
        if(getOldFiles.length > 0 && filesData.length > 0) {
          getOldFiles.map((f) => {
            var fname = f.attachmentsUrl.split('/')[2];
            fs.unlinkSync('./public/welfareImages/'+fname);
          })
          await this.welfarefilesRepository.delete({welfareId:WelfareDTO.Id});
        }
        const savedWelfare = await this.welfarefilesRepository.save(filesData);
        const welfareRespone = await this.welfareRepository.findOne({
          relations:['welfaretype'],
                    where:{Id:WelfareDTO.Id}
        });
        if (welfareRespone) {
          const user = await this.profileService.getUserByUId(welfareRespone.userId);
          const village = await this.villageService.getVillageById(welfareRespone.villageId);
          const postImages = await this.welfarefilesRepository.find({
              where:{welfareId:welfareRespone.Id}
          });
          if(postImages) {
            postImages.map((i) => {
                images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
            })
          }
          const final = {
            Id: welfareRespone.Id,
            text:welfareRespone.text,
            welfaretypeId:welfareRespone.welfaretypeId,
            welfaretype:welfareRespone.welfaretype!=null?welfareRespone.welfaretype.welfareType:'',
            welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new',
            firstName: welfareRespone.firstName,
            lastName: welfareRespone.lastName,
            mobileNo: welfareRespone.mobileNo,
            email: welfareRespone.email,
            address: welfareRespone.address,
            villageId:welfareRespone.villageId,
            villageName:village!=null?village.villageName:'',
            amount:welfareRespone.amount,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.userId,
            userName: user!=null?user.firstName:'',
            profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
            postImages:images,                        
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'welfare record updated';
          response.intlCode = 11108;
          response.data = final;
        } else {
          throw new ErrorResponse(99998, 'Welfare record update failed');
        }
      } else  {
        const updatePostType = await this.welfareRepository.update(WelfareDTO.Id, finaObj);
        const getOldFiles = await this.welfarefilesRepository.find({
          where:{welfareId:WelfareDTO.Id}
        })
        if(getOldFiles.length > 0 && filesData.length > 0) {
          getOldFiles.map((f) => {
            var fname = f.attachmentsUrl.split('/')[2];
            fs.unlinkSync('./public/welfareImages/'+fname);
          })
          await this.welfarefilesRepository.delete({welfareId:WelfareDTO.Id});
        }
        const savedWelfare = await this.welfarefilesRepository.save(filesData);
        const welfareRespone = await this.welfareRepository.findOne({
          relations:['welfaretype'],
                    where:{Id:WelfareDTO.Id}
        });
        if (welfareRespone) {
          const user = await this.profileService.getUserByUId(welfareRespone.userId);
          const village = await this.villageService.getVillageById(welfareRespone.villageId);
          const postImages = await this.welfarefilesRepository.find({
              where:{welfareId:welfareRespone.Id}
          });
          if(postImages) {
            postImages.map((i) => {
                images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
            })
          }
          const final = {
            Id: welfareRespone.Id,
            text:welfareRespone.text,
            welfaretypeId:welfareRespone.welfaretypeId,
            welfaretype:welfareRespone.welfaretype!=null?welfareRespone.welfaretype.welfareType:'',
            welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new',
            firstName: welfareRespone.firstName,
            lastName: welfareRespone.lastName,
            mobileNo: welfareRespone.mobileNo,
            email: welfareRespone.email,
            address: welfareRespone.address,
            villageId:welfareRespone.villageId,
            villageName:village!=null?village.villageName:'',
             amount:welfareRespone.amount,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.userId,
            userName: user!=null?user.firstName:'',
            profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
            postImages:images,                        
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'welfare record updated';
          response.intlCode = 11108;
          response.data = final;
        } else {
          throw new ErrorResponse(99998, 'Welfare record update failed');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }    
  }

  async getAllActiveWelfare(queryParams,userId, request:Request): Promise<AllWelfareResponseModel>{
    const response = new AllWelfareResponseModel();
    try{
      let images: any[] = [];
      const finalData: any[] = [];
      const user = await this.profileService.getUserByUId(userId);
      if (queryParams.apiVersion == 1) {
        if(queryParams.type == 0) {
        	if (user.user.roleId == 1 || user.user.roleId == 2) {
        		if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: {status: true},
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });

                   
                } else {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: {status:true,welfaretypeId:queryParams.welfaretypeId},
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                }
        	} else if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                var welfare = await this.welfareRepository.find({
                relations:['welfaretype'],
                where: [{status: true,userId:userId},
                {status:true,mobileNo:user.mobileNo}],
                order: { createdAt: 'DESC' },
                skip:queryParams.skip,
                take:10
                });
        	} else {
                var welfare = await this.welfareRepository.find({
                relations:['welfaretype'],
                where: [{status: true,userId:userId,welfaretypeId:queryParams.welfaretypeId},
                {status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId},],
                order: { createdAt: 'DESC' },
                skip:queryParams.skip,
                take:10
                });
        	}
         
        } else if(queryParams.type == 1) {
        	if (user.user.roleId == 1 || user.user.roleId == 2) {
        		if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'new',status:true},
                        {currentStatus:'Yet to start',status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                } else {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'new',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'Yet to start',status:true,welfaretypeId:queryParams.welfaretypeId},],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                }
        	} else if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'new'},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'Yet to start'},
                    {currentStatus:'new',status:true,mobileNo:user.mobileNo},
                    {currentStatus:'Yet to start',userId:userId,status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    } else {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'new',welfaretypeId:queryParams.welfaretypeId},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'Yet to start',welfaretypeId:queryParams.welfaretypeId},
                    {currentStatus:'new',status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId},
                    {currentStatus:'Yet to start',userId:userId,status:true,welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    }
        } else if(queryParams.type == 2) {
        	if (user.user.roleId == 1 || user.user.roleId == 2) {
        		if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'in progress',status:true},
                        {currentStatus:'inprogress',status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                } else {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'in progress',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'inprogress',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {status:true,welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                }
        	} else if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'in progress'},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'inprogress'},
                    {currentStatus:'in progress',mobileNo:user.mobileNo,status:true},
                    {currentStatus:'inprogress',userId:userId,status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    } else {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'in progress',welfaretypeId:queryParams.welfaretypeId},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'inprogress',welfaretypeId:queryParams.welfaretypeId},
                    {currentStatus:'in progress',mobileNo:user.mobileNo,status:true,welfaretypeId:queryParams.welfaretypeId},
                    {currentStatus:'inprogress',userId:userId,status:true,welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    }
        } else if(queryParams.type == 3) {
        	if (user.user.roleId == 1 || user.user.roleId == 2) {
        		if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'completed',status:true},
                        {currentStatus:'closed',status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                } else {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'completed',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'closed',status:true,welfaretypeId:queryParams.welfaretypeId},],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                }
        	} else  if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'completed'},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'completed'},
                    {status: true,userId:userId,currentStatus:'closed'},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'closed'},],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    } else {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'completed',welfaretypeId:queryParams.welfaretypeId},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'completed',welfaretypeId:queryParams.welfaretypeId},
                    {status: true,userId:userId,currentStatus:'closed',welfaretypeId:queryParams.welfaretypeId},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'closed',welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    }
        } 
       
        if(!welfare) {
          throw new ErrorResponse(99908,'Data not found')
        }
        const promises = welfare.map(async (post) => {
          const user = await this.profileService.getUserByUId(post.userId);
          const village = await this.villageService.getVillageById(post.villageId);
          const postImages = await this.welfarefilesRepository.find({
              where:{welfareId:post.Id}
          });
          return {
              Id: post.Id,
              text:post.text,
              welfaretypeId:post.welfaretypeId,
              welfaretype:post.welfaretype!=null?post.welfaretype.welfareType:'',
              welfareStatus:post.currentStatus!=null?post.currentStatus:'new',
              firstName: post.firstName,
              lastName: post.lastName,
              mobileNo: post.mobileNo,
              email: post.email,
              address: post.address,
              villageId:post.villageId,
              villageName:village!= null?village.villageName:'',
              amount:post.amount,
              createdAt:post.createdAt,
              userId:post.userId,
              userName: user!=null?user.firstName:'',
              profilePic:user!=null?user.profilePic:'',
              postImages:postImages,
          }   
        });   
        const da = await Promise.all(promises);
        da.map((f) => {  
            if(f.postImages) {
                f.postImages.map((i) => {
                    images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                })
            }                        
            finalData.push({
              Id: f.Id,
              text:f.text,
              welfaretypeId:f.welfaretypeId,
              welfaretype:f.welfaretype,
              welfareStatus:f.welfareStatus,
              firstName: f.firstName,
              lastName: f.lastName,
              mobileNo: f.mobileNo,
              email: f.email,
              address: f.address,
              villageId:f.villageId,
              villageName:f.villageName,
              amount:f.amount,
              createdAt:f.createdAt,
              userId:f.userId,
              userName: f.firstName,
              profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
              postImages:images,                        
            }) 
            images=[];
        }) 

        if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined || queryParams.welfaretypeId == '')  { 
            if(user.user.roleId == 1 || user.user.roleId == 2) {
                var allDevPosts = await this.welfareRepository.find({
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
            } else {
                var allDevPosts = await this.welfareRepository.find({
                    where: [{status: true,userId:userId},
                        {status:true,mobileNo:user.mobileNo}],
                    order: { createdAt: 'DESC' }
                });
            }
            
        } else {
            
            if(user.user.roleId == 1 || user.user.roleId == 2) {
                var allDevPosts = await this.welfareRepository.find({
                    where: {status: true,welfaretypeId:queryParams.welfaretypeId},
                    order: { createdAt: 'DESC' }
                });
            } else {
                var allDevPosts = await this.welfareRepository.find({
                    where: [{status: true,userId:userId,welfaretypeId:queryParams.welfaretypeId},
                        {status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' }
                });
            }
        }
        
     
        if(allDevPosts) {
          var totalDevcnt = allDevPosts.length;
          var totalAmt = 0;
          allDevPosts.map((s) => {
            totalAmt += s.amount
          })
        } else {
          var totalDevcnt = 0;
          var totalAmt = 0;
        }                
        if(totalDevcnt == 0) {
          response.status = true;
          response.data = finalData;  
          response.percentData =  {
            totalAmount:totalAmt,
            allCount:totalDevcnt,
            newAmount:0,
            newCount:0,
            newPercentage: 0,
            inProgressAmount: 0,
            inProgressCount:0,
            inProgressPercentage:0,
            closedAmount:0,
            closedCount:0,
            closedPercentage:0
          }
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;
        } else {  
            if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined || queryParams.welfaretypeId == '')  { 
                if(user.user.roleId == 1 || user.user.roleId == 2) {
                    var cmptDevPosts = await this.welfareRepository.find({
                        where:[{currentStatus:'completed',status:true},
                        {currentStatus:'closed',status:true}],
                        order: {createdAt: "DESC"}
                    });

                    var progressDevPosts = await this.welfareRepository.find({
                        where:[{currentStatus:'inprogress',status:true},
                        {currentStatus:'in progress',status:true}],
                        order: {createdAt: "DESC"}
                    });

                    var newDevPosts = await this.welfareRepository.find({
                      where:[{currentStatus:'new',status:true},
                      {currentStatus:'Yet to start',status:true}],
                        order: {createdAt: "DESC"}
                    });
                } else {
                    var cmptDevPosts = await this.welfareRepository.find({
                        where: [{status: true,userId:userId,currentStatus:'completed'},
                            {status:true,mobileNo:user.mobileNo,currentStatus:'completed'},
                            {status: true,userId:userId,currentStatus:'closed'},
                            {status:true,mobileNo:user.mobileNo,currentStatus:'closed'}],
                        order: { createdAt: 'DESC' }
                    });

                    var progressDevPosts = await this.welfareRepository.find({
                        where:[{status: true,userId:userId,currentStatus:'inprogress'},
                        {status:true,mobileNo:user.mobileNo,currentStatus:'inprogress'},
                        {status: true,userId:userId,currentStatus:'in progress'},
                        {status:true,mobileNo:user.mobileNo,currentStatus:'in progress'}],
                        order: {createdAt: "DESC"}
                    });

                    var newDevPosts = await this.welfareRepository.find({
                      where:[{currentStatus:'new',status:true,userId:userId},
                      {currentStatus:'new',status:true,mobileNo:user.mobileNo},
                      {currentStatus:'Yet to start',status:true,mobileNo:user.mobileNo},
                      {currentStatus:'Yet to start',status:true,userId:userId}],
                        order: {createdAt: "DESC"}
                    });
                }
                
            } else {
                
                if(user.user.roleId == 1 || user.user.roleId == 2) {
                    var cmptDevPosts = await this.welfareRepository.find({
                        where:[{currentStatus:'completed',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'closed',status:true,welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                      });

                    var progressDevPosts = await this.welfareRepository.find({
                        where:[{currentStatus:'inprogress',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'in progress',status:true,welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                    });

                    var newDevPosts = await this.welfareRepository.find({
                      where:[{currentStatus:'new',status:true,welfaretypeId:queryParams.welfaretypeId},
                      {currentStatus:'Yet to start',status:true,welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                    });

                } else {
                    var cmptDevPosts = await this.welfareRepository.find({
                        where: [{status: true,userId:userId,currentStatus:'completed',welfaretypeId:queryParams.welfaretypeId},
                            {status:true,mobileNo:user.mobileNo,currentStatus:'completed',welfaretypeId:queryParams.welfaretypeId},
                            {status: true,userId:userId,currentStatus:'closed',welfaretypeId:queryParams.welfaretypeId},
                            {status:true,mobileNo:user.mobileNo,currentStatus:'closed',welfaretypeId:queryParams.welfaretypeId}],
                        order: { createdAt: 'DESC' }
                    });
                    var progressDevPosts = await this.welfareRepository.find({
                        where:[{status: true,userId:userId,currentStatus:'inprogress',welfaretypeId:queryParams.welfaretypeId},
                        {status:true,mobileNo:user.mobileNo,currentStatus:'inprogress',welfaretypeId:queryParams.welfaretypeId},
                        {status: true,userId:userId,currentStatus:'in progress',welfaretypeId:queryParams.welfaretypeId},
                        {status:true,mobileNo:user.mobileNo,currentStatus:'in progress',welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                    });
                    var newDevPosts = await this.welfareRepository.find({
                      where:[{currentStatus:'new',status:true,userId:userId,welfaretypeId:queryParams.welfaretypeId},
                      {currentStatus:'new',status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId},
                      {currentStatus:'Yet to start',status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId},
                      {currentStatus:'Yet to start',status:true,userId:userId,welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                    });
                }
            }        
          
            if(cmptDevPosts) {
                var cmptDevcnt = cmptDevPosts.length;
                var closedAmount = 0;
                cmptDevPosts.map((s) => {
                    closedAmount += s.amount;
                })
            } else {
                var cmptDevcnt = 0;
                var closedAmount = 0; 
            }
          
            if(progressDevPosts) {
                var prgrsDevcnt = progressDevPosts.length;
                var inProgressAmount = 0;
                progressDevPosts.map((s) => {
                    inProgressAmount += s.amount;
                })
            } else {
                var prgrsDevcnt = 0;
                var inProgressAmount = 0;
            }          
          
          if(newDevPosts) {
              var newDevcnt = newDevPosts.length;
              var newAmount = 0;
              newDevPosts.map((s) => {
                newAmount += s.amount;
            })
          } else {
              var newDevcnt = 0;
              var newAmount = 0;
          }
          var newPer = newDevcnt == 0? 0 : Math.round((newDevcnt/totalDevcnt)*100);
          var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
          var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
          response.status = true;
          response.data = finalData;
          response.percentData = {
            totalAmount:totalAmt,
            allCount:totalDevcnt,
            newAmount:newAmount,
            newCount:newDevcnt,
            newPercentage: newPer,
            inProgressAmount: inProgressAmount,
            inProgressCount:prgrsDevcnt,
            inProgressPercentage:inproPer,
            closedAmount: closedAmount,
            closedCount:cmptDevcnt,
            closedPercentage:cmptPer
          }
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;
        }  
      } else {
        if(queryParams.type == 0) {
        	if (user.user.roleId == 1 || user.user.roleId == 2) {
        		if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: {status: true},
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });

                   
                } else {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: {status:true,welfaretypeId:queryParams.welfaretypeId},
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                }
        	} else if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                var welfare = await this.welfareRepository.find({
                relations:['welfaretype'],
                where: [{status: true,userId:userId},
                {status:true,mobileNo:user.mobileNo}],
                order: { createdAt: 'DESC' },
                skip:queryParams.skip,
                take:10
                });
        	} else {
                var welfare = await this.welfareRepository.find({
                relations:['welfaretype'],
                where: [{status: true,userId:userId,welfaretypeId:queryParams.welfaretypeId},
                {status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId},],
                order: { createdAt: 'DESC' },
                skip:queryParams.skip,
                take:10
                });
        	}
         
        } else if(queryParams.type == 1) {
        	if (user.user.roleId == 1 || user.user.roleId == 2) {
        		if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'new',status:true},
                        {currentStatus:'Yet to start',status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                } else {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'new',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'Yet to start',status:true,welfaretypeId:queryParams.welfaretypeId},],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                }
        	} else if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'new'},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'Yet to start'},
                    {currentStatus:'new',status:true,mobileNo:user.mobileNo},
                    {currentStatus:'Yet to start',userId:userId,status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    } else {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'new',welfaretypeId:queryParams.welfaretypeId},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'Yet to start',welfaretypeId:queryParams.welfaretypeId},
                    {currentStatus:'new',status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId},
                    {currentStatus:'Yet to start',userId:userId,status:true,welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    }
        } else if(queryParams.type == 2) {
        	if (user.user.roleId == 1 || user.user.roleId == 2) {
        		if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'in progress',status:true},
                        {currentStatus:'inprogress',status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                } else {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'in progress',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'inprogress',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {status:true,welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                }
        	} else if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'in progress'},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'inprogress'},
                    {currentStatus:'in progress',mobileNo:user.mobileNo,status:true},
                    {currentStatus:'inprogress',userId:userId,status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    } else {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'in progress',welfaretypeId:queryParams.welfaretypeId},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'inprogress',welfaretypeId:queryParams.welfaretypeId},
                    {currentStatus:'in progress',mobileNo:user.mobileNo,status:true,welfaretypeId:queryParams.welfaretypeId},
                    {currentStatus:'inprogress',userId:userId,status:true,welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    }
        } else if(queryParams.type == 3) {
        	if (user.user.roleId == 1 || user.user.roleId == 2) {
        		if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'completed',status:true},
                        {currentStatus:'closed',status:true}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                } else {
                    var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [
                        {currentStatus:'completed',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'closed',status:true,welfaretypeId:queryParams.welfaretypeId},],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                    });
                }
        	} else  if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined) {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'completed'},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'completed'},
                    {status: true,userId:userId,currentStatus:'closed'},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'closed'},],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    } else {
                var welfare = await this.welfareRepository.find({
                    relations:['welfaretype'],
                    where: [{status: true,userId:userId,currentStatus:'completed',welfaretypeId:queryParams.welfaretypeId},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'completed',welfaretypeId:queryParams.welfaretypeId},
                    {status: true,userId:userId,currentStatus:'closed',welfaretypeId:queryParams.welfaretypeId},
                    {status:true,mobileNo:user.mobileNo,currentStatus:'closed',welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take:10
                });
		    }
        } 
       
        if(!welfare) {
          throw new ErrorResponse(99908,'Data not found')
        }
        const promises = welfare.map(async (post) => {
          const user = await this.profileService.getUserByUId(post.userId);
          const village = await this.villageService.getVillageById(post.villageId);
          const postImages = await this.welfarefilesRepository.find({
              where:{welfareId:post.Id}
          });
          return {
              Id: post.Id,
              text:post.text,
              welfaretypeId:post.welfaretypeId,
              welfaretype:post.welfaretype!=null?post.welfaretype.welfareType:'',
              welfareStatus:post.currentStatus!=null?post.currentStatus:'new',
              firstName: post.firstName,
              lastName: post.lastName,
              mobileNo: post.mobileNo,
              email: post.email,
              address: post.address,
              villageId:post.villageId,
              villageName:village!= null?village.villageName:'',
              amount:post.amount,
              createdAt:post.createdAt,
              userId:post.userId,
              userName: user!=null?user.firstName:'',
              profilePic:user!=null?user.profilePic:'',
              postImages:postImages,
          }   
        });   
        const da = await Promise.all(promises);
        da.map((f) => {  
            if(f.postImages) {
                f.postImages.map((i) => {
                    images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                })
            }                        
            finalData.push({
              Id: f.Id,
              text:f.text,
              welfaretypeId:f.welfaretypeId,
              welfaretype:f.welfaretype,
              welfareStatus:f.welfareStatus,
              firstName: f.firstName,
              lastName: f.lastName,
              mobileNo: f.mobileNo,
              email: f.email,
              address: f.address,
              villageId:f.villageId,
              villageName:f.villageName,
              amount:f.amount,
              createdAt:f.createdAt,
              userId:f.userId,
              userName: f.firstName,
              profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
              postImages:images,                        
            }) 
            images=[];
        }) 

        if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined || queryParams.welfaretypeId == '')  { 
            if(user.user.roleId == 1 || user.user.roleId == 2) {
                var allDevPosts = await this.welfareRepository.find({
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
            } else {
                var allDevPosts = await this.welfareRepository.find({
                    where: [{status: true,userId:userId},
                        {status:true,mobileNo:user.mobileNo}],
                    order: { createdAt: 'DESC' }
                });
            }
            
        } else {
            
            if(user.user.roleId == 1 || user.user.roleId == 2) {
                var allDevPosts = await this.welfareRepository.find({
                    where: {status: true,welfaretypeId:queryParams.welfaretypeId},
                    order: { createdAt: 'DESC' }
                });
            } else {
                var allDevPosts = await this.welfareRepository.find({
                    where: [{status: true,userId:userId,welfaretypeId:queryParams.welfaretypeId},
                        {status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId}],
                    order: { createdAt: 'DESC' }
                });
            }
        }
        
     
        if(allDevPosts) {
          var totalDevcnt = allDevPosts.length;
          var totalAmt = 0;
          allDevPosts.map((s) => {
            totalAmt += s.amount
          })
        } else {
          var totalDevcnt = 0;
          var totalAmt = 0;
        }                
        if(totalDevcnt == 0) {
          response.status = true;
          response.data = finalData;  
          response.percentData =  {
            totalAmount:totalAmt,
            allCount:totalDevcnt,
            newAmount:0,
            newCount:0,
            newPercentage: 0,
            inProgressAmount: 0,
            inProgressCount:0,
            inProgressPercentage:0,
            closedAmount:0,
            closedCount:0,
            closedPercentage:0
          }
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;
        } else {  
            if(queryParams.welfaretypeId == 0 || queryParams.welfaretypeId == undefined || queryParams.welfaretypeId == '')  { 
                if(user.user.roleId == 1 || user.user.roleId == 2) {
                    var cmptDevPosts = await this.welfareRepository.find({
                        where:[{currentStatus:'completed',status:true},
                        {currentStatus:'closed',status:true}],
                        order: {createdAt: "DESC"}
                    });

                    var progressDevPosts = await this.welfareRepository.find({
                        where:[{currentStatus:'inprogress',status:true},
                        {currentStatus:'in progress',status:true}],
                        order: {createdAt: "DESC"}
                    });

                    var newDevPosts = await this.welfareRepository.find({
                      where:[{currentStatus:'new',status:true},
                      {currentStatus:'Yet to start',status:true}],
                        order: {createdAt: "DESC"}
                    });
                } else {
                    var cmptDevPosts = await this.welfareRepository.find({
                        where: [{status: true,userId:userId,currentStatus:'completed'},
                            {status:true,mobileNo:user.mobileNo,currentStatus:'completed'},
                            {status: true,userId:userId,currentStatus:'closed'},
                            {status:true,mobileNo:user.mobileNo,currentStatus:'closed'}],
                        order: { createdAt: 'DESC' }
                    });

                    var progressDevPosts = await this.welfareRepository.find({
                        where:[{status: true,userId:userId,currentStatus:'inprogress'},
                        {status:true,mobileNo:user.mobileNo,currentStatus:'inprogress'},
                        {status: true,userId:userId,currentStatus:'in progress'},
                        {status:true,mobileNo:user.mobileNo,currentStatus:'in progress'}],
                        order: {createdAt: "DESC"}
                    });

                    var newDevPosts = await this.welfareRepository.find({
                      where:[{currentStatus:'new',status:true,userId:userId},
                      {currentStatus:'new',status:true,mobileNo:user.mobileNo},
                      {currentStatus:'Yet to start',status:true,mobileNo:user.mobileNo},
                      {currentStatus:'Yet to start',status:true,userId:userId}],
                        order: {createdAt: "DESC"}
                    });
                }
                
            } else {
                
                if(user.user.roleId == 1 || user.user.roleId == 2) {
                    var cmptDevPosts = await this.welfareRepository.find({
                        where:[{currentStatus:'completed',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'closed',status:true,welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                      });

                    var progressDevPosts = await this.welfareRepository.find({
                        where:[{currentStatus:'inprogress',status:true,welfaretypeId:queryParams.welfaretypeId},
                        {currentStatus:'in progress',status:true,welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                    });

                    var newDevPosts = await this.welfareRepository.find({
                      where:[{currentStatus:'new',status:true,welfaretypeId:queryParams.welfaretypeId},
                      {currentStatus:'Yet to start',status:true,welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                    });

                } else {
                    var cmptDevPosts = await this.welfareRepository.find({
                        where: [{status: true,userId:userId,currentStatus:'completed',welfaretypeId:queryParams.welfaretypeId},
                            {status:true,mobileNo:user.mobileNo,currentStatus:'completed',welfaretypeId:queryParams.welfaretypeId},
                            {status: true,userId:userId,currentStatus:'closed',welfaretypeId:queryParams.welfaretypeId},
                            {status:true,mobileNo:user.mobileNo,currentStatus:'closed',welfaretypeId:queryParams.welfaretypeId}],
                        order: { createdAt: 'DESC' }
                    });
                    var progressDevPosts = await this.welfareRepository.find({
                        where:[{status: true,userId:userId,currentStatus:'inprogress',welfaretypeId:queryParams.welfaretypeId},
                        {status:true,mobileNo:user.mobileNo,currentStatus:'inprogress',welfaretypeId:queryParams.welfaretypeId},
                        {status: true,userId:userId,currentStatus:'in progress',welfaretypeId:queryParams.welfaretypeId},
                        {status:true,mobileNo:user.mobileNo,currentStatus:'in progress',welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                    });
                    var newDevPosts = await this.welfareRepository.find({
                      where:[{currentStatus:'new',status:true,userId:userId,welfaretypeId:queryParams.welfaretypeId},
                      {currentStatus:'new',status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId},
                      {currentStatus:'Yet to start',status:true,mobileNo:user.mobileNo,welfaretypeId:queryParams.welfaretypeId},
                      {currentStatus:'Yet to start',status:true,userId:userId,welfaretypeId:queryParams.welfaretypeId}],
                        order: {createdAt: "DESC"}
                    });
                }
            }        
          
            if(cmptDevPosts) {
                var cmptDevcnt = cmptDevPosts.length;
                var closedAmount = 0;
                cmptDevPosts.map((s) => {
                    closedAmount += s.amount;
                })
            } else {
                var cmptDevcnt = 0;
                var closedAmount = 0; 
            }
          
            if(progressDevPosts) {
                var prgrsDevcnt = progressDevPosts.length;
                var inProgressAmount = 0;
                progressDevPosts.map((s) => {
                    inProgressAmount += s.amount;
                })
            } else {
                var prgrsDevcnt = 0;
                var inProgressAmount = 0;
            }          
          
          if(newDevPosts) {
              var newDevcnt = newDevPosts.length;
              var newAmount = 0;
              newDevPosts.map((s) => {
                newAmount += s.amount;
            })
          } else {
              var newDevcnt = 0;
              var newAmount = 0;
          }
          var newPer = newDevcnt == 0? 0 : Math.round((newDevcnt/totalDevcnt)*100);
          var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
          var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
          response.status = true;
          response.data = finalData;
          response.percentData = {
            totalAmount:totalAmt,
            allCount:totalDevcnt,
            newAmount:newAmount,
            newCount:newDevcnt,
            newPercentage: newPer,
            inProgressAmount: inProgressAmount,
            inProgressCount:prgrsDevcnt,
            inProgressPercentage:inproPer,
            closedAmount: closedAmount,
            closedCount:cmptDevcnt,
            closedPercentage:cmptPer
          }
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;
        }          
      }  
      return response;
    }catch( err) {
      throw err;
    }
  }

  async getWelfareByWelfareId(queryParams, welfareId: number, request:Request): Promise<SingleWelfareResponseModel> {
      const response = new SingleWelfareResponseModel();
      try {
        let images: any[] = [];
        if (queryParams.apiVersion == 1) {
          const welfareRespone = await this.welfareRepository.findOne({
            relations:['welfaretype'],
                      where:{Id:welfareId}
          });
          if (welfareRespone) {
            const user = await this.profileService.getUserByUId(welfareRespone.userId);
            const village = await this.villageService.getVillageById(welfareRespone.villageId);
            const postImages = await this.welfarefilesRepository.find({
                where:{welfareId:welfareRespone.Id}
            });
            if(postImages) {
              postImages.map((i) => {
                  images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
              })
            }
            const final = {
              Id: welfareRespone.Id,
              text:welfareRespone.text,
              welfaretypeId:welfareRespone.welfaretypeId,
              welfaretype:welfareRespone.welfaretype!=null?welfareRespone.welfaretype.welfareType:'',
              welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new',
              firstName: welfareRespone.firstName,
              lastName: welfareRespone.lastName,
              mobileNo: welfareRespone.mobileNo,
              email: welfareRespone.email,
              address: welfareRespone.address,
              villageId:welfareRespone.villageId,
              villageName:village!=null?village.villageName:'',
              amount:welfareRespone.amount,
              createdAt:welfareRespone.createdAt,
              userId:welfareRespone.userId,
              userName: user!=null?user.firstName:'',
              profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
              postImages:images,                        
            }
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'welfare record found';
            response.intlCode = 11107;
            response.data = final;
          } else {
            throw new ErrorResponse(99998, 'Welfare record not found');
          }
        } else {
          const welfareRespone = await this.welfareRepository.findOne({
            relations:['welfaretype'],
                      where:{Id:welfareId}
          });
          if (welfareRespone) {
            const user = await this.profileService.getUserByUId(welfareRespone.userId);
            const village = await this.villageService.getVillageById(welfareRespone.villageId);
            const postImages = await this.welfarefilesRepository.find({
                where:{welfareId:welfareRespone.Id}
            });
            if(postImages) {
              postImages.map((i) => {
                  images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
              })
            }
            const final = {
              Id: welfareRespone.Id,
              text:welfareRespone.text,
              welfaretypeId:welfareRespone.welfaretypeId,
              welfaretype:welfareRespone.welfaretype!=null?welfareRespone.welfaretype.welfareType:'',
              welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new',
              firstName: welfareRespone.firstName,
              lastName: welfareRespone.lastName,
              mobileNo: welfareRespone.mobileNo,
              email: welfareRespone.email,
              address: welfareRespone.address,
              villageId:welfareRespone.villageId,
              villageName:village!=null?village.villageName:'',
              amount:welfareRespone.amount,
              createdAt:welfareRespone.createdAt,
              userId:welfareRespone.userId,
              userName: user!=null?user.firstName:'',
              profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
              postImages:images,                        
            }
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'welfare record found';
            response.intlCode = 11107;
            response.data = final;
          } else {
            throw new ErrorResponse(99998, 'Welfare record not found');
          }
        }
        return response;
      } catch (error) {
        throw error;
      }
  } 

  /* async getActiveWelfareCount(queryParams, request:Request): Promise<WelfareStatusWiseResponseModel> {
      const response = new WelfareStatusWiseResponseModel();
      try {
        if(queryParams.apiVersion == 1) {
          const welfareStatusWiseCount = await getConnection()
          .createQueryBuilder()
          .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
          .from(WelfareEntity, "Welfare")
          .orderBy('status','ASC')
          .getRawOne();
          if (welfareStatusWiseCount) {
            response.status = true;
            response.active = welfareStatusWiseCount.activeCount;
            response.inActive = welfareStatusWiseCount.inActiveCount;
            response.total = welfareStatusWiseCount.cnt;
            response.statusCode = 50000;
            response.internalMessage = 'Data retrieved successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        } else {
          const welfareStatusWiseCount = await getConnection()
          .createQueryBuilder()
          .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
          .from(WelfareEntity, "Welfare")
          .orderBy('status','ASC')
          .getRawOne();
          if (welfareStatusWiseCount) {
            response.status = true;
            response.active = welfareStatusWiseCount.activeCount;
            response.inActive = welfareStatusWiseCount.inActiveCount;
            response.total = welfareStatusWiseCount.cnt;
            response.statusCode = 50000;
            response.internalMessage = 'Data retrieved successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        }
        return response;
      } catch (err) {
        throw err;
      }
  } */

  async updateWelfareStatus(queryParams,welfareDeleteDto:WelfareDeleteDTO, request:Request):Promise<WelfareResponseModel>{
      const response = new WelfareResponseModel();
      try {
        if(queryParams.apiVersion == 1) {
          welfareDeleteDto.updatedUser = welfareDeleteDto.userId;
          const welfare =await this.welfareRepository.update(welfareDeleteDto.Id,welfareDeleteDto);
          if (welfare) {
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'welfare deleted successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'welfare delete failed');
          }
        } else {
          welfareDeleteDto.updatedUser = welfareDeleteDto.userId;
          const welfare =await this.welfareRepository.update(welfareDeleteDto.Id,welfareDeleteDto);
          if (welfare) {
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'welfare deleted successfully';
            response.intlCode = 11108;
          } else {
          throw new ErrorResponse(99998, 'welfare delete failed');
          }
        }      
        return response;
      } catch (error) {
        throw error;
      }
  }

  async changeWelfareStatus(queryParams,welfareStatusDto:WelfareStatusDto, request:Request):Promise<SingleWelfareResponseModel>{
    const response = new SingleWelfareResponseModel();
    try {
      const user = await this.profileService.getUserByUId(welfareStatusDto.userId); 
      user.firstName = user.firstName!=null?user.firstName:'';
      await this.welfarestatusRepository.update({
        welfareId:welfareStatusDto.welfareId
      },{status:false})
      if(queryParams.apiVersion == 1) {
        welfareStatusDto.updatedUser = welfareStatusDto.userId;
        await this.welfareRepository.update({Id:welfareStatusDto.welfareId},{currentStatus:welfareStatusDto.welfareStatus});
        await this.welfarestatusRepository.save({
          welfareId:welfareStatusDto.welfareId,
          userId:welfareStatusDto.userId,
          welfareStatus:welfareStatusDto.welfareStatus,
          createdUser:welfareStatusDto.userId
        });
        const welfare = await this.welfareRepository.findOne({
          relations:['welfaretype'],
          where: { Id:welfareStatusDto.welfareId },
        });
        if (welfare) {
          let msg = {
            to : `${user.user.fcmToken}`,
            collapse_key : "type_a",
            notification : {
              body : `Your Welfare Status Changed as ${welfareStatusDto.welfareStatus}`,
              title: "Change Welfare Status"
            },
            data : {
              body : `Your Welfare Status Changed as ${welfareStatusDto.welfareStatus}`,
              title: "Change Welfare Status",
              key_1 : "",
              key_2 : ""
            }
          }
          await this.notifyRepo.save({
            title:'Change Welfare Status',
            message:`Your Welfare Status Changed as ${welfareStatusDto.welfareStatus}`,
            typeId:5,
            userId:welfareStatusDto.userId,
            targetId:welfareStatusDto.welfareId,
            status:true
          })
          if(user.user.fcmToken) {                  
            await this.sendNotify(msg);
          }
          const newUsr = await this.profileService.getProfileByPhone(welfare.mobileNo);
          if(newUsr) {
            let msg1 = {
              to : `${newUsr.user.fcmToken}`,
              collapse_key : "type_a",
              notification : {
                body : `Your Welfare status changed by ${user.firstName} as ${welfareStatusDto.welfareStatus}`,
                title: "Change Welfare Status"
              },
              data : {
                body : `Your Welfare status changed by ${user.firstName} as ${welfareStatusDto.welfareStatus}`,
                title: "Change Welfare Status",
                key_1 : "",
                key_2 : ""
              }
            }
            await this.notifyRepo.save({
              title:'Change Welfare Status',
              message:`Your Welfare status changed by ${user.firstName} as ${welfareStatusDto.welfareStatus}`,
              typeId:5,
              userId:newUsr.userId,
              targetId:welfareStatusDto.welfareId,
              status:true
            })                  
            if(newUsr.user.fcmToken) {
              await this.sendNotify(msg1);
            }
          }
          response.status = true;
          response.data = welfare;
          response.statusCode = 50000;
          response.internalMessage = 'welfare status updated successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'welfare status update failed');
        }
      } else {
        welfareStatusDto.updatedUser = welfareStatusDto.userId;
        await this.welfareRepository.update({Id:welfareStatusDto.welfareId},{currentStatus:welfareStatusDto.welfareStatus});
        await this.welfarestatusRepository.save({
          welfareId:welfareStatusDto.welfareId,
          userId:welfareStatusDto.userId,
          welfareStatus:welfareStatusDto.welfareStatus,
          createdUser:welfareStatusDto.userId
        });
        const welfare = await this.welfareRepository.findOne({
          relations:['welfaretype'],
          where: { Id:welfareStatusDto.welfareId },
        });
        if (welfare) {
          let msg = {
            to : `${user.user.fcmToken}`,
            collapse_key : "type_a",
            notification : {
              body : `Your Welfare Status Changed as ${welfareStatusDto.welfareStatus}`,
              title: "Change Welfare Status"
            },
            data : {
              body : `Your Welfare Status Changed as ${welfareStatusDto.welfareStatus}`,
              title: "Change Welfare Status",
              key_1 : "",
              key_2 : ""
            }
          }
          await this.notifyRepo.save({
            title:'Change Welfare Status',
            message:`Your Welfare Status Changed as ${welfareStatusDto.welfareStatus}`,
            typeId:5,
            userId:welfareStatusDto.userId,
            targetId:welfareStatusDto.welfareId,
            status:true
          })
          if(user.user.fcmToken) {                  
            await this.sendNotify(msg);
          }
          const newUsr = await this.profileService.getProfileByPhone(welfare.mobileNo);
          if(newUsr) {
            let msg1 = {
              to : `${newUsr.user.fcmToken}`,
              collapse_key : "type_a",
              notification : {
                body : `Your Welfare status changed by ${user.firstName} as ${welfareStatusDto.welfareStatus}`,
                title: "Change Welfare Status"
              },
              data : {
                body : `Your Welfare status changed by ${user.firstName} as ${welfareStatusDto.welfareStatus}`,
                title: "Change Welfare Status",
                key_1 : "",
                key_2 : ""
              }
            }
            await this.notifyRepo.save({
              title:'Change Welfare Status',
              message:`Your Welfare status changed by ${user.firstName} as ${welfareStatusDto.welfareStatus}`,
              typeId:5,
              userId:newUsr.userId,
              targetId:welfareStatusDto.welfareId,
              status:true
            })                  
            if(newUsr.user.fcmToken) {
              await this.sendNotify(msg1);
            }
          }
          response.status = true;
          response.data = welfare;
          response.statusCode = 50000;
          response.internalMessage = 'welfare status updated successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'welfare status update failed');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getAllActiveWelfareByUID(userId) {
    let images: any[] = [];
    const finalData: any[] = [];
    const welfare = await this.welfareRepository.find({
      relations:['welfaretype'],
      where: {status: true,userId:userId},
      order: { createdAt: 'DESC' },
    });
    if(!welfare) {
      return null;
    }
    const promises = welfare.map(async (post) => {
      const user = await this.profileService.getUserByUId(post.userId);
      const village = await this.villageService.getVillageById(post.villageId);
      const postImages = await this.welfarefilesRepository.find({
        where:{welfareId:post.Id}
      });
      return {
        Id: post.Id,
        text:post.text,
        welfaretypeId:post.welfaretypeId,
        welfaretype:post.welfaretype!=null?post.welfaretype.welfareType:'',
        welfareStatus:post.currentStatus!=null?post.currentStatus:'new',
        firstName: post.firstName,
        lastName: post.lastName,
        mobileNo: post.mobileNo,
        email: post.email,
        address: post.address,
        villageId:post.villageId,
        villageName:village!= null?village.villageName:'',
        amount:post.amount,
        createdAt:post.createdAt,
        userId:post.userId,
        userName: user!=null?user.firstName:'',
        profilePic:user!=null?user.profilePic:'',
        postImages:postImages,
      }   
    });   
    const da = await Promise.all(promises);
    da.map((f) => {  
      if(f.postImages) {
        f.postImages.map((i) => {
          images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
        })
      }                        
      finalData.push({
        Id: f.Id,
        text:f.text,
        welfaretypeId:f.welfaretypeId,
        welfaretype:f.welfaretype,
        welfareStatus:f.welfareStatus,
        firstName: f.firstName,
        lastName: f.lastName,
        mobileNo: f.mobileNo,
        email: f.email,
        address: f.address,
        villageId:f.villageId,
        villageName:f.villageName,
        amount:f.amount,
        createdAt:f.createdAt,
        userId:f.userId,
        userName: f.firstName,
        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
        postImages:images,                        
      }) 
      images=[];
    }) 
    return  finalData;
  }

}


